// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__rfsdi","messages":"Chat_messages__1uMcf","dateDivider":"Chat_dateDivider__3JG83"};